import React from 'react';
import styles from './wordList.module.scss';
import { useCustomTranslation } from '../../../../../../translation/customTranslation';
import { Checkbox } from '../../../../../../components/checkBox/checkBox';
import { ToggleButtonMultipleSelection } from '../../../../../../components/toggleButtonMultipleSelection/toggleButtonMultipleSelection';

export interface TrialProps {
  wordsRecalled?: string[];
  noAnswersCorrect?: boolean;
}

export interface ImmediateMemoryWordsListProps {
  wordListKey: string;
  wordsPresented: string[];
  setResponse: any;
  onSaveNoAnswersCorrect: (
    notTestedKey: string,
    notTestedValue: boolean,
    selectionKey?: string,
  ) => void;
  data: TrialProps;
}

export function ImmediateMemoryWordsList({
  wordListKey,
  wordsPresented,
  setResponse,
  onSaveNoAnswersCorrect,
  data,
}: ImmediateMemoryWordsListProps) {
  const { t } = useCustomTranslation('assessment');

  return (
    <>
      <div className={styles.outerContainer}>
        {wordsPresented?.map((word: any) => {
          return (
            <div key={t(word.key)} className={styles.outerContainer}>
              <ToggleButtonMultipleSelection
                key={t(word.key)}
                questionKey={t(word.key)}
                responseValue={false}
                label={t(word.key)}
                onAnswerSelect={setResponse}
                data={data?.wordsRecalled}
                type="standard"
                size="small"
              />
            </div>
          );
        })}
      </div>
      <Checkbox
        label={t('ID_IMMEDIATE_MEMORY_IF_FAILED_TO_RECALL')}
        checked={data?.noAnswersCorrect}
        size="small"
        onChange={(event) =>
          onSaveNoAnswersCorrect(
            'noAnswersCorrect',
            event.target.checked,
            wordListKey,
          )
        }
        name={`${wordListKey}FailedToRecall`}
      />
    </>
  );
}
